import { Box, Typography } from '@mui/material'
import React from 'react'

const PreviewBox = ({ children }) => {
  return (
    <Box mt={2}>
      <Typography>End user preview</Typography>
      <Box
        sx={{
          marginTop: '8px',
          padding: '16px',
          borderRadius: '6px',
          border: '1px dashed #BCBCBC',
          background: '#FAFAFA'
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default PreviewBox
